import { KnowledgeManagement } from "@/v2/features/knowledge-management";

export default function KnowledgeManagementPage() {
  return <KnowledgeManagement />;
}

